import { PropType, defineComponent, onUnmounted, watch } from 'vue'
import { ChargeMapContext } from '../chargerMap/index.model'
import { useRoute, useRouter } from 'vue-router'
import { Store } from 'pinia'
import { ComponentActions, ComponentState } from '../../nsh5/localStores/component'
import code2simple from '../../config/code2simple'
import { getCityInfo } from '../../utils/gis'
import { MapViewMode, Point } from '../../contract/map'
import { closeToast, showToast } from '@nio-fe/horo-h5'
import { DEFAULT_POSITION } from '../../config/defaultPosition'
import { getLocation } from '../../apis/map.api'
import { useAppStore } from '../../stores/app'
import { DEFAULT_COUNTRY_ZOOM_LEVEL } from '../../config/zoomLevelConfig'

export default defineComponent({
  name: 'county-layout-view',
  props: {
    mapContextRef: {
      type: Object as PropType<ChargeMapContext>,
    },
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
  },
  setup: (props) => {
    const router = useRouter()
    const route = useRoute()
    let region_code: any
    // 获取组件配置
    const componentsConfig: any = window.NSComponentsConfig

    const locationFlyTo = (myLocation: Point) => {
      closeToast()
      getLocation(myLocation, 'setMyLocation').then((res: any) => {
        const locInfo = res.data
        props.componentStore.$patch({
          myLocation: locInfo,
        })
        locInfo &&
          props.componentStore.bus.emit(
            'selectCity',
            getCityInfo(code2simple[locInfo.code.slice(0, 4) + '00'].simple)
          )
      })
    }
    const flyToCountyLayoutLocationCity = () => {
      // 没有指定的情况下，默认到定位的城市
      if (props.componentStore.myLocation) {
        // 有缓存走缓存
        props.componentStore.bus.emit(
          'selectCity',
          getCityInfo(code2simple[props.componentStore.myLocation.code.slice(0, 4) + '00'].simple)
        )
      } else {
        showToast({
          content: '正在定位...',
          duration: 3000,
        })
        props.mapContextRef
          ?.getCurrentPosition()
          .then((loc: Point) => {
            console.log('====================================')
            console.log('flyToCountyLayoutLocationCity定位成功', loc)
            console.log('====================================')
            locationFlyTo(loc)
          })
          .catch(async () => {
            console.log('====================================')
            console.log('flyToCountyLayoutLocationCity定位失败-默认定位', DEFAULT_POSITION)
            console.log('====================================')
            // 未获取到定位采取默认定位
            locationFlyTo(DEFAULT_POSITION)
          })
      }
    }
    props.componentStore.bus.on('flyToCountyLayoutLocationCity', flyToCountyLayoutLocationCity)
    /**
     * 组件获取地图实例后的回调
     */
    const onReady = async () => {
      if (window.location.href.includes('/county_layout')) {
        if (componentsConfig.county_layout?.show) {
          const info =
            route.query.region_code !== '000000'
              ? code2simple[route.query.region_code as string]
              : null
          region_code = info ? (route.query.region_code as string) : '' // 如果有参数才需要带上
          window.backHistoryNum = 0
          await router.replace({
            name: 'home',
            state: {
              backHistoryNum: window.backHistoryNum,
            },
          }) // 为了保证回退时回到首页
          window.backHistoryNum++
          const params = {
            name: 'countyLayout',
            query: {},
            state: {
              backHistoryNum: window.backHistoryNum,
            },
          } as any
          if (region_code) {
            params.query.region_code = region_code
          }
          await router.push(params)
          if (region_code) {
            console.log('region_code', region_code)
            props.componentStore.bus.emit(
              'selectCity',
              getCityInfo(code2simple[region_code].simple)
            )
          } else {
            // flyToCountyLayoutLocationCity()   // watch 里会处理
          }
          props.componentStore.$patch({
            showHandleBox: false,
          })
          props.componentStore.$patch({
            showSummary: false,
          })
        } else {
          window.backHistoryNum = 0
          await router.replace({
            name: 'home',
            state: {
              backHistoryNum: window.backHistoryNum,
            },
          }) // 为了保证回退时回到首页
          props.componentStore.$patch({
            showHandleBox: false,
          })
          props.componentStore.$patch({
            showSummary: true,
          })
          props.componentStore.bus.emit('onChangeHeightLevel', 1) // dragPopup高度回到1
        }
      }
    }
    watch(
      () => props.mapContextRef,
      () => {
        if (props.mapContextRef) {
          onReady()
        }
      },
      {
        immediate: true,
      }
    )
    watch(
      () => props.componentStore.viewMode,
      () => {
        if (props.componentStore.viewMode === MapViewMode.CountyLayout && !region_code) {
          flyToCountyLayoutLocationCity()
        }
      }
    )
    onUnmounted(() => {
      props.componentStore.bus.off('flyToCountyLayoutLocationCity')
    })
    return () => {}
  },
})
